import {Component, Input} from "@angular/core";
import {QrCodePageComponent} from "../qr-code-page/qr-code-page.component";
import {NavigationService} from "../../../orchestration/navigation.service";

@Component({
    selector: "woa-qr-code-panel",
    templateUrl: "./qr-code-panel.component.html",
})
export class QrCodePanelComponent {
    @Input() value: string;
    @Input() displayValue: string;
    @Input() message: string;

    constructor(private navigationService: NavigationService) {
    }

    public async expand(event?: Event): Promise<void> {
        event.stopPropagation();
        return QrCodePageComponent.showQrCode(this.navigationService, this.value, this.message, this.displayValue);
    }
}



// WEBPACK FOOTER //
// ./src/app/ui-elements/qr-code/qr-code-panel/qr-code-panel.component.ts